import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Table,
  Col,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
// import DefaultImg from "../../../assets/images/product/Default_img.jpg";

import { ExportToExcel } from "../../Common/ExportToExcel";
import { getPIreportslist } from "../../../store/Reports/actions";
import "../reports.scss";
var date = new Date(),
  y = date.getFullYear(),
  m = date.getMonth();
class PIReportList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.getPIreportslist({
      ...this.props.params,
      start_date:
        this.props.params.start_date == null ||
        this.props.params.start_date === ""
          ? moment(new Date(y, m, 1)).format("YYYY-MM-DD")
          : this.props.params.start_date,
      end_date:
        this.props.params.end_date == null || this.props.params.end_date === ""
          ? moment(new Date()).add(1, "days").format("YYYY-MM-DD")
          : moment(this.props.params.end_date)
              .add(1, "days")
              .format("YYYY-MM-DD"),
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col md={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom no-print">
                    <Link
                      to="/pireport"
                      className="action-icon text-primary mr-2"
                    >
                      <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                    </Link>
                    <div className="float-right">
                      <div className="d-inline-block ">
                        <ExportToExcel
                          apiData={this.props.PI_ReportData.map((pi) => {
                            return {
                              "PI Code": pi.code,
                              Location: pi.location.name,
                              Department: pi.userdepartment.name,
                              "Submited On": moment(pi.createdon).format(
                                "DD-MM-YYYY"
                              ),
                              Status: pi.pistatus_name,
                              "Created By":
                                pi.createdby.fullname +
                                " (" +
                                pi.createdby.username +
                                ")",
                            };
                          })}
                          topHeader={[
                            "SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD",
                            "Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist. - AP",
                            "Phone No.0884-2326661, 62, Mobile No.9494127893, Email: purchase@sleipl.com, lalitharice@gmail.com",
                            "",
                            "PURCHASE INDENT REPORT",
                            "",
                          ]}
                          fileName="PURCHASE_INDENT_REPORT"
                        />

                        <Button
                          type="button"
                          outline
                          color="secondary"
                          className="ml-2"
                          onClick={() => window.print()}
                        >
                          <i className="mdi  mdi-printer"></i>
                          <span className="d-none d-inline-block ml-1">
                            Print
                          </span>
                        </Button>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-2">
                    <div className="text-center">
                      <span className="display_none printme">
                        <h5 className="card-title-18 pt-2 ">
                          SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD
                        </h5>
                        <p className="card-title-14 pt-2 mb-0">
                          Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist.
                          - AP
                        </p>
                        <p className="card-title-14 pt-2">
                          Phone No.0884-2326661, 62, Mobile No.9494127893,
                          Email: purchase@sleipl.com, lalitharice@gmail.com
                        </p>
                        <hr />
                      </span>
                      <h5 className="card-title-16 pt-3 ">
                        PURCHASE INDENT REPORT ({" "}
                        {this.props.params.start_date == null ||
                        this.props.params.start_date === ""
                          ? moment(new Date(y, m, 1)).format(
                              "DD-MM-YYYY"
                            )
                          : moment(this.props.params.start_date).format(
                            "DD-MM-YYYY"
                          )}{" "}
                        TO{" "}
                        {moment(this.props.params.end_date).format(
                          "DD-MM-YYYY"
                        )}{" "}
                        )
                      </h5>
                    </div>

                    <div className="table-responsive m-0">
                      <Table
                        bordered
                        hover
                        className="mb-0 p-0 table-centered"
                        id="table-to-xls"
                      >
                        <thead className="bg-light text-center">
                          <tr className="bg-light">
                            <th className="nowrap">
                              <b>PI Code</b>
                            </th>
                            <th className="nowrap">
                              <b>Location</b>
                            </th>
                            <th className="nowrap">
                              <b>Department</b>
                            </th>
                            <th className="nowrap">
                              <b>Submited On</b>
                            </th>

                            <th className="nowrap">
                              <b>Status</b>
                            </th>
                            <th className="nowrap">
                              <b>Created By</b>
                            </th>
                          </tr>
                        </thead>
                        <tbody className="nowrap">
                          {this.props.PI_ReportData.length !== 0 ? (
                            <>
                              {this.props.PI_ReportData.map((pi, key) => (
                                <>
                                  <tr key={key} className="text-center">
                                    <td>{pi.code}</td>
                                    <td>{pi.location.name}</td>
                                    <td>{pi.userdepartment.name}</td>

                                    <td>
                                      {moment(pi.createdon).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </td>
                                    <td>{pi.pistatus_name}</td>
                                    <td>
                                      {pi.createdby.fullname} (
                                      {pi.createdby.username})
                                    </td>
                                  </tr>
                                </>
                              ))}
                            </>
                          ) : (
                            <tr>
                              <td colspan="7" className="text-center">
                                <span className="font-size-18 text-danger">
                                  Data not available
                                </span>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { params, reportType, Reportdata, PI_ReportData } = state.reports;
  return {
    params,
    reportType,
    Reportdata,
    PI_ReportData,
  };
};

export default connect(mapStatetoProps, {
  getPIreportslist,
})(PIReportList);
